import React from "react";
import { useSelector } from "react-redux";
import { getCompanyConfig } from "selectors/appSelector";
import AddNewProperty from "./AddNewProperty";
import AddProjProperty from "./AddProjProperty";

export const WrapperAddProperty = () => {
  const { projEqualProp } = useSelector(getCompanyConfig);

  if (projEqualProp) {
    return <AddProjProperty />;
  }

  return <AddNewProperty />;
};
export default WrapperAddProperty;
